<template>
	<div class="video_div" ref="myvideoContainer" @resize="handleResize()" >
		<div ref="myvideo" v-if="showVideoFlag || mode==0 || mode==2"></div>
		<div class="video_box" @click="onClickShowVideo" v-else>
			<img   :src="poster" mode="aspectFill" class="img"/>
			<img src="@/assets/img/bf.png" mode="aspectFit" class="img-play"/></image>
      {{mode}}
		</div>
	</div>
</template>

<script>
	import videojs from "video.js"
	import "video.js/dist/video-js.css"
	export default {
		name: "myvideo",
		props: {
			source: {
				type: String,
				default: ""
			},
			height: {
				type: String,
				default: "100%"
			},
			width: {
				type: String,
				default: "100%"
			},
			poster: {
				type: String,
				default: ""
			},
			type: {
				type: String,
				default: "videojs", // videojs or aliplayer
			},
			cbData: {
				type: String,
				default: "",
			},
			cbPlay: {
				type: Function,
				default: null,
			},
			mode: {
				type: Number,
				default: 2, //0: 预加载: 播放速度快，占用内存大 1: 动态加载 2: 懒加载
			},
			isFix:{
				type: Boolean,
				default:false
			},
			isStop:{
				type: Boolean,
				default:false
			}
		},
		watch: {
			source(){
				this.createPlayer();
			}
		},
		data() {
			return {
				playerId: "myvideo_id_" + this.cbData,
				instance: null,
				showVideoFlag: false,
				throttleLoad: null,
				isFullScreen:false,
				timer:null
			};
		},
		mounted() {
			//console.log("==========mounted", this.playerId, this.instance)
			this.createPlayer();
			window.addEventListener('resize', this.handleResize)
		},
		destroyed() {
			//console.log("==========destroyed", this.playerId)
			this.disposeVideo()
			window.removeEventListener("resize", this.handleResize)
		},
		methods: {
			onClickShowVideo() {
				console.log("==========onClickShowVideo")
				const that = this
				this.showVideoFlag = true
				this.createPlayer()
				this.$nextTick(function(){
					this.play()
				})
			},
			// 是否不在屏幕可见区内
			isNotVisible() {
				//{"bottom":325.5625,"height":279.5625,"left":-61,"right":436,"top":46,"width":497,"x":-61,"y":46}
                const rect = this.$refs.myvideoContainer.getBoundingClientRect();
				return (
					rect.bottom <= 0 ||
					rect.top >= (window.innerHeight || document.documentElement.clientHeight)
				);
			},
			handleScroll() {
				if (document.fullscreenElement) {
					console.log("handleScroll is in full screen!", this.playerId)
					return
				}
				//console.log("handleScroll", this.playerId)
				if (this.isNotVisible()) {
					this.instance != null && this.disposeVideo()
				} else {
					//console.log("show", this.playerId)
					this.instance == null && this.createPlayer()
				}
			},
			disposeVideo() {
				//console.log("disposeVideo", this.playerId)
				this.instance && this.instance.dispose()
				this.instance = null
			},
			initVideojs() {
				let that = this;
				const w = this.$refs.myvideoContainer.offsetWidth;
				const h = this.$refs.myvideoContainer.offsetHeight;
				console.log(h);
				var video = document.createElement('video')
				video.id = that.playerId
				if(that.isFix){
					video.style = "background-size: 100% 100%;object-fit: fill;width:"+that.width+'px;height:'+that.height+'px';
				}else{
					video.style = "background-size: 100% 100%;object-fit: fill";
				}
				
				video.controls = true
				video.className = "video-js vjs-default-skin vjs-big-play-centered" //vjs-big-play-centered可使大的播放按钮居住，vjs-fluid可使视频占满容器
				video.setAttribute('playsinline', true) //IOS微信浏览器支持小窗内播放
				video.setAttribute('webkit-playsinline', true) //这个bai属性是ios 10中设置可以让视频在小du窗内播放，也就是不是全zhi屏播放的video标签的一个属性
				video.setAttribute('x5-video-player-type', 'h5') //安卓 声明启用同层H5播放器 可以在video上面加东西
				var source = document.createElement('source')
				source.src = that.source
				source.type = "application/x-mpegURL"
				video.appendChild(source)
				that.$refs.myvideo.appendChild(video)
				// https://docs.videojs.com/player
				var poster = this.poster
				var autoplay = true;
				if(this.isStop){
					autoplay = false;
				}
				this.instance = videojs(this.playerId, {
					poster: poster,
					width: w,
					height: h,
					videoWidth: w,
					videoHeight: h,
					// aspectRatio: w+':'+h,
					autoDisable: true,
					preload: 'auto', //auto - 当页面加载后载入整个视频 meta - 当页面加载后只载入元数据 none - 当页面加载后不载入视频
					language: 'zh-CN',
					loop: true,
					fluid: false,
					muted: true,
					controls: autoplay,
					autoplay: autoplay,
					// screenshot: true,
					techOrder: ["html5", "flash"],
					html5: {
						vhs: {
							enableLowInitialPlaylist: true,
							bandwidth: 99999,
						}
					}
				}, function onPlayerReady() {
					var myPlayer = this;
                    myPlayer.play();
					myPlayer.on('error', function() {
						console.error("video player error!")
					})
					myPlayer.on('play', function() {
						console.log("myPlayer play ...")
						that.cbPlay && that.cbPlay(that.cbData)
					})
					myPlayer.on("fullscreenchange", (e) => {
						console.log("fullscreenchange", e);
						let isFullScreen = that.isFullScreen;
						if(!isFullScreen){
							that.isFullScreen = true;
						}else{
							that.isFullScreen = true;
							if(that.timer){
								clearTimeout(that.timer);
							}
							setTimeout(function(){
								that.isFullScreen = false;
							},200);
						}
					})
				})
			},
			initAliplayer() {
				let that = this
				var aliplayer_div = document.createElement('div')
				aliplayer_div.id = this.playerId
				aliplayer_div.className = 'prism-player'
				this.$refs.myvideo.appendChild(aliplayer_div)
				that.instance = window.Aliplayer({
					id: that.playerId,
					source: that.source,
					width: that.width,
					height: that.height,
					videoWidth: that.width,
					videoHeight: that.height,
					preload: true,
					/* Aliplayer: 动加载(preload)和自动播放(autoplay)为 false 时，才生效 */
					cover: that.poster,
					isLive: true,
					autoplay: true,
					useH5Prism: true,
					playsinline: true,
					controlBarVisibility: "hover",
					language: "zh-cn",
				});
				that.instance.on("error", () => {
					console.error("video player error!")
					//this.$emit("error", that.instance);
				});
				that.instance.on("play", () => {
					//this.$emit("play", _this.instance);
					console.log("myPlayer play ...")
					that.cbPlay && that.cbPlay(that.cbData)
				});
			},
			play() {
				this.instance && this.instance.play()
			},
			createPlayer() {
				let that = this
				this.$nextTick(function(){
					that.disposeVideo()
					var childs = that.$refs.myvideo.childNodes;
					for(var i = 0; i < childs.length; i++) {
						if(childs[i]){
							that.$refs.myvideo.removeChild(childs[i])
							childs[i].remove()
						}
					}
					that.$refs.myvideo.innerHTML = ""
					if (that.type == "videojs") {
						that.initVideojs()
					} else if (that.type == "aliplayer") {
						that.initAliplayer()
					}
				})
			},
			reloadPlayer() {
				// reset the player to default image page
				
				if (this.mode == 0 || this.mode == 2) {
					this.createPlayer()
				} else {
					this.showVideoFlag = false
				}
			},
			handleResize(){
				let that = this;
				setTimeout(function(){
					let isFullScreen = that.isFullScreen;
					if(!isFullScreen){
						that.disposeVideo();
						that.createPlayer();
					}
				},100);
			}
		},
		
	};
</script>
<style>
  .video_div,.video_box{
    width: 100%;
    height: 100%;
  }
 
	/* for aliplayer */
	.prism-player .prism-big-play-btn {
	    display: none;
	    z-index: 1000;
		top: 50%;
		left: 50%;
	}
	/* for videojs */
	.vjs-poster {
		background-size: 100% 100% !important;
	}
	.img {
		width: 100;
		height: 100;
	}
	.img-play {
		width: 80px;
		height: 80px;
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translateX(-50%) translateY(-50%);
	}
</style>
